import userService from '@/service/userService'
import axios from 'axios'
import MainPresenter from "@/service/MainPresenter"
import appConfig from '@/service/config'
import moment from 'moment'
import un from 'underscore'
import { escapeParam } from "@/service/UrlEncoder"

const mainPresenter = new MainPresenter();

const ReportsService = function() {

    function buildParamsAddReports(requestData) {
        return {
            ... requestData,
            ... { createDate: moment(requestData.createDate).format("YYYY-MM-DD HH:mm:ss") }
        }
    }
    
    this.addComment = function(requestData, onSuccess, onError) {
        const commentForm = {
            content: requestData.content,
            reportId: requestData.reportId,
            createDate: moment().format("YYYY-MM-DD HH:mm:ss")
        }
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + '/reports/addComment',
            data: commentForm,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    this.addReport = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + '/reports',
            data: buildParamsAddReports(requestData),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    this.editReport = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + '/reports/' + requestData.reportId,
            data: buildParamsAddReports(requestData),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    this.deleteReport = function(id, onSuccess, onError) {
        const req = axios({
            method: 'delete',
            url: appConfig.baseUrl + '/reports',
            data: {
                "reportId": id
            },
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    this.findReport = function(id, onSuccess, onError) {
        const req = axios({
            method: 'get',
            url: `${appConfig.baseUrl}/reports/${id}`,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        })
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            onError(e)
        })
    }

    function buildParamsSearch(requestData) {
        return {
            "storeId": requestData.params.storeId,
            "itemsPage": requestData.pageable.page,
            "itemsSize": 60
        }
    }

    this.search = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'get',
            url: mainPresenter.getUrlForParams("/reports", buildParamsSearch(requestData)),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            onError(e)
        })
    }

    this.isAdmin = function() {
        return userService.isAdmin()
    }

    this.initStores = function(onSuccess) {
        axios.get(mainPresenter.buildUrlWithDefaults("/allStores?visible=true")).then(response => {
            const currentStoreId = userService.getCurrentStore()
            const currentStore = un.find(response.data.content, function(item) {
                return item.id === currentStoreId
            })
            if (this.isAdmin()) {
                onSuccess(response.data.content, currentStore);
            } else {
                onSuccess([currentStore], currentStore);
            }
        }, err => {
            console.log(err)
        })
    }

    return {
        "search": this.search,
        "initStores": this.initStores,
        "isAdmin": this.isAdmin,
        "addReport": this.addReport,
        "findReport": this.findReport,
        "deleteReport": this.deleteReport,
        "editReport": this.editReport,
        "addComment": this.addComment
    }
}


export default ReportsService;


// WEBPACK FOOTER //
// ./src/components/reports/ReportsService.js